import { render, staticRenderFns } from "./TransferContract.vue?vue&type=template&id=826f273a&scoped=true&"
import script from "./TransferContract.vue?vue&type=script&lang=js&"
export * from "./TransferContract.vue?vue&type=script&lang=js&"
import style0 from "./TransferContract.vue?vue&type=style&index=0&id=826f273a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f273a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VForm,VIcon})
